import { Component, OnInit } from '@angular/core';
import { LOCALE_ID } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormControl, FormGroup } from '@angular/forms';
import { SubmissionService } from '../_services/submission.service';
import { ClientService } from 'app/_services/client.service';
import { BuildingService } from 'app/_services/building.service';
import { PropositionService } from 'app/_services/proposition.service';
import { TemplateService } from '../_services/template.service';
import { NoteService } from 'app/_services/note.service';
import { FileService } from 'app/_services/file.service';
import { TokenStorageService } from '../_services/token-storage.service';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import {formatDate} from '@angular/common';
import flatpickr from "flatpickr";
import * as moment from 'moment'; 


@Component({
  selector: 'app-submissions',
  templateUrl: './edit-submission.component.html',
  styleUrls: ['./submissions.component.scss']
})
export class EditSubmissionComponent implements OnInit {
  baseUrl = environment.baseUrl;
  contactUUID: string = "";
  submissionId: number = 0;
  clientId: number = 0;
  clientInfo: any = [];
  invoiceInfo: any = {};
  buildingId: number = 0;

  roofTypesList: any = [];
  roofAccessList: any = [];
  buildingTypesList: any = [];
  buildingAccessTypesList: any = [];
  buildingInfo: any = [];
  submissionStateInfo: any = [];
  templatesList: any = [];
  propositionsList: any = [];
  submissionInfo: any = {};
  
  //files: any = "";
  fileList: File[] = [];
  uploadedFiles: any = [];
  filesUpload: any = [];
  fileName: string = '';
  fileSize: number = 0;

  propositionTemplateId: number = 0;
  propositionTemplateName: string = "";
  propositionTemplate: any = "";
  propositionEmailDate: any = "";

  singleProposition: any = [];
  propositionId: number = 0;
  propositionName: string = "";
  propositionCreated: string = "";
  propositionLastUpdated: string = "";
  propositionFirstSent: string = "";
  propositionContent: any = "";
  update_message: string = "";
  update_message_prop: string = "";
  update_message_upload: string = "";
  update_message_suivi: string = "";
  latest_appointment_date_planned: any = false; 
  suiviNotesList: any = [];
  calendarPick: any;
  isForeman: any = false; 

  editSubmissionForm: FormGroup = new FormGroup({
    is_refused: new FormControl(""),
    is_scheduled: new FormControl(""),
    is_accepted: new FormControl(""),
    is_signed: new FormControl(""),
    is_sent: new FormControl(""),
    fileList: new FormControl(""),
    uploadedFiles: new FormControl(""),

    submission_no: new FormControl(""),
    soumission_created_date: new FormControl(""),
    created_by_name: new FormControl(""),
    latest_appointment_date: new FormControl(""),
    is_job_planned: new FormControl(""),
    latest_job_date: new FormControl(""),
    build_date: new FormControl(""),

    building_updated: new FormControl(""),
    address: new FormControl(""),
    address2: new FormControl(""),
    city: new FormControl(""),
    province: new FormControl(""),
    country: new FormControl(""),
    postalcode: new FormControl(""),
    roof_type_id: new FormControl(""),
    roof_description: new FormControl(""),
    roof_access: new FormControl(""),
    is_new: new FormControl(""),

    building_type_id: new FormControl(""),
    building_description: new FormControl(""),
    building_access_id: new FormControl(""),
    has_water_infiltration: new FormControl(""),
    water_infiltration: new FormControl(""),
    building_age: new FormControl(""), //owner sincee
    roof_date: new FormControl(""),//date de refabrication du toit
    is_roof_redone: new FormControl(""),
    description: new FormControl(""),
    is_suivi_active: new FormControl(""),
   
  })

  addPropositionForm: FormGroup = new FormGroup({
    template_id: new FormControl(""),
    proposition_name: new FormControl(""),
    proposition_content: new FormControl("")
  })

  updatePropositionForm: FormGroup = new FormGroup({
    proposition_name: new FormControl(""),
    proposition_content: new FormControl("")
  })


  constructor(
    private http: HttpClient,
    private activatedRoute: ActivatedRoute,
    private tokenStorage: TokenStorageService,
    private router: Router,
    private submissions: SubmissionService,
    private clients: ClientService,
    private buildings: BuildingService,
    private templates: TemplateService,
    private propositions: PropositionService,
    private notes: NoteService,
    private files: FileService
  ) { }

  ckEditorWithImageConfig = {
    'default': {
        'versionCheck': false
    }
  };

  ngOnInit(): void {
    this.contactUUID = this.tokenStorage.getToken() || "";
    this.submissionId = this.activatedRoute.snapshot.params['submissionid'];
    moment.locale('fr');

    
//set invoice ID
    this.invoiceInfo.invoice_id = 1;
    this.invoiceInfo.invoice_no = '1229';

//set foreman account   
    const user = this.tokenStorage.getUser();
    if(user['account_id'] == 20) {
      this.isForeman = true;
    }

    this.addPropositionForm.addControl('template_id', new FormControl(""));
    this.addPropositionForm.addControl('proposition_name', new FormControl(""));
    this.addPropositionForm.addControl('proposition_content', new FormControl(""));

    this.submissions.getRoofTypes$(this.contactUUID).subscribe({
      next: data => {
        this.roofTypesList = data;
      },
      error: err => {
        console.log("Something went wrong fetching roof types: ", err)
      }
    });
    
    this.buildings.getBuildingTypes$(this.contactUUID).subscribe({
      next: data => {
        this.buildingTypesList = data;
      },
      error: err => {
        console.log("Something went wrong fetching building types: ", err)
      }
    });
    
    this.submissions.getRoofAccessTypes$(this.contactUUID).subscribe({
      next: data => {
        this.buildingAccessTypesList = data;
      },
      error: err => {
        console.log("Something went wrong fetching roof access types: ", err)
      }
    });

    this.templates.getTemplatesList$(this.contactUUID).subscribe({
      next: data => {
        this.templatesList = data;
      },
      error: err => {
        console.log("Something went wrong fetching templates: ", err)
      }
    });

    //type one is notes of submission
    this.notes.getNotesOfSubmission$(this.contactUUID, 1, this.submissionId).subscribe({
      next: data => {
        this.suiviNotesList = data //.reverse();
        console.log('this.suiviNotesList', this.suiviNotesList);

        for (let suiviNote of this.suiviNotesList ){
          suiviNote.created = moment(new Date(suiviNote.created)).locale('fr').format('D MMMM YYYY LT');
          suiviNote.start_date = moment(new Date(suiviNote.start_date)).locale('en').format('D MMMM YYYY');
          suiviNote.end_date = moment(new Date(suiviNote.end_date)).locale('fr').format('D MMMM YYYY');
        }
                  //suivis
                  
                  for (let i = 0; i < this.suiviNotesList.length; i++) {
                    this.editSubmissionForm.addControl('note_id_'+i, new FormControl(""));
                    this.editSubmissionForm.controls['note_id_'+i].patchValue(this.suiviNotesList[i].note_id);
                    this.editSubmissionForm.addControl('note_start_date_'+i, new FormControl(""));
                    this.editSubmissionForm.controls['note_start_date_'+i].patchValue(this.suiviNotesList[i].start_date);
                    this.editSubmissionForm.addControl('note_end_date_'+i, new FormControl(""));
                    this.editSubmissionForm.controls['note_end_date_'+i].patchValue(this.suiviNotesList[i].end_date);
                    this.editSubmissionForm.addControl('note_suivi_'+i, new FormControl(""));
                    this.editSubmissionForm.controls['note_suivi_'+i].patchValue(this.suiviNotesList[i].body);
            
                    console.log('i', i, this.suiviNotesList[i]);
                   }
             
              
        console.log('this.suiviNotesList ', this.suiviNotesList );
      },
      error: err => {
        console.log("Something went wrong fetching notes: ", err)
      }
    });

    this.submissions.getSubmission$(this.submissionId, this.contactUUID).subscribe({
      next: data => {

        this.submissionInfo = data;
        this.clientId = data.client_id;
        this.buildingId = data.building_id;
        this.uploadedFiles = data.files;

        for (let i = 0; i < this.uploadedFiles.length; i++) {
          this.uploadedFiles[i].download = this.uploadedFiles[i].subject;
        }

        console.log('this.submissionInfo',this.submissionInfo);
        console.log('files', this.uploadedFiles);
        console.log('buildingId', this.buildingId);

        //console.log('client id', this.clientId);

        this.getClient(this.clientId);
        this.getBuildingInfo(this.buildingId);

        if(this.submissionInfo.latest_appointment_date == null || this.submissionInfo.latest_appointment_date == '' ){
          this.latest_appointment_date_planned=false;
        }else{
          this.latest_appointment_date_planned=true;
        }

        this.submissionInfo.soumission_created_date_visual = moment(new Date(this.submissionInfo.created)).format('YYYY-MM-DD HH:mm');
        this.submissionInfo.latest_appointment_date = (this.submissionInfo.latest_appointment_date!= null)? moment(new Date(this.submissionInfo.latest_appointment_date)).format('YYYY-MM-DD HH:mm'): '';
        this.submissionInfo.latest_job_date = (this.submissionInfo.latest_job_date != null)? moment(new Date(this.submissionInfo.latest_job_date)).format('YYYY-MM-DD HH:mm') : '';
        this.submissionInfo.is_job_planned = (this.submissionInfo.latest_job_date != null)? true : false;

        this.editSubmissionForm.controls['is_refused'].patchValue(this.submissionInfo.is_refused);
        this.editSubmissionForm.controls['is_scheduled'].patchValue(this.submissionInfo.is_scheduled);
        this.editSubmissionForm.controls['is_accepted'].patchValue(this.submissionInfo.is_accepted);
        this.editSubmissionForm.controls['is_signed'].patchValue(this.submissionInfo.is_signed);
        this.editSubmissionForm.controls['is_sent'].patchValue(this.submissionInfo.is_sent);
        //submission details
        this.editSubmissionForm.controls['submission_no'].patchValue(this.submissionInfo.submission_no);
        this.editSubmissionForm.controls['soumission_created_date'].patchValue(moment(this.submissionInfo.created).format('YYYY-MM-DD'));
        this.editSubmissionForm.controls['created_by_name'].patchValue(this.submissionInfo.created_by_name);
        this.editSubmissionForm.controls['latest_appointment_date'].patchValue( moment(new Date(this.submissionInfo.latest_appointment_date)).format('YYYY-MM-DD HH:mm'));
        this.editSubmissionForm.controls['is_job_planned'].patchValue(this.submissionInfo.is_job_planned);
        this.editSubmissionForm.controls['latest_job_date'].patchValue(moment(new Date(this.submissionInfo.latest_job_date)).format('YYYY-MM-DD HH:mm'));

         // Building Infos
         this.editSubmissionForm.controls['building_updated'].patchValue(this.submissionInfo.building_updated);
         this.editSubmissionForm.controls['build_date'].patchValue( this.submissionInfo.build_date);
         this.editSubmissionForm.controls['address'].patchValue(this.submissionInfo.address);
         this.editSubmissionForm.controls['address2'].patchValue(this.submissionInfo.address2);
         this.editSubmissionForm.controls['city'].patchValue(this.submissionInfo.city);
         this.editSubmissionForm.controls['province'].patchValue(this.submissionInfo.province);
         this.editSubmissionForm.controls['country'].patchValue(this.submissionInfo.country);
         this.editSubmissionForm.controls['postalcode'].patchValue(this.submissionInfo.postalcode);
         this.editSubmissionForm.controls['roof_type_id'].patchValue(this.submissionInfo.roof_type_id);
         this.editSubmissionForm.controls['roof_description'].patchValue(this.submissionInfo.roof_description);
         this.editSubmissionForm.controls['roof_access'].patchValue(this.submissionInfo.roof_access);
         this.editSubmissionForm.controls['is_roof_redone'].patchValue(this.submissionInfo.is_roof_redone);
         this.editSubmissionForm.controls['is_new'].patchValue(this.submissionInfo.is_new);
         this.editSubmissionForm.controls['building_type_id'].patchValue(this.submissionInfo.building_type_id);
         this.editSubmissionForm.controls['building_description'].patchValue(this.submissionInfo.building_description);
         this.editSubmissionForm.controls['building_access_id'].patchValue(this.submissionInfo.building_access_id);
         this.editSubmissionForm.controls['has_water_infiltration'].patchValue(this.submissionInfo.has_water_infiltration);
         this.editSubmissionForm.controls['water_infiltration'].patchValue(this.submissionInfo.water_infiltration);
         this.editSubmissionForm.controls['building_age'].patchValue(this.submissionInfo.building_age);
         this.editSubmissionForm.controls['roof_date'].patchValue(this.submissionInfo.roof_date);
         this.editSubmissionForm.controls['description'].patchValue(this.submissionInfo.description);
         //files
         this.editSubmissionForm.controls['fileList'].patchValue(this.fileList);
         this.editSubmissionForm.controls['uploadedFiles'].patchValue(this.submissionInfo.files);
         //suivis
         this.editSubmissionForm.controls['is_suivi_active'].patchValue(this.submissionInfo.is_suivi_active);

         for (let i = 0; i < this.suiviNotesList.length; i++) {
            this.editSubmissionForm.controls['note_id_'+i].patchValue(this.suiviNotesList[i].note_id);
            this.editSubmissionForm.controls['note_start_date_'+i].patchValue(this.suiviNotesList[i].start_date);
            this.editSubmissionForm.controls['note_end_date_'+i].patchValue(this.suiviNotesList[i].end_date);
            this.editSubmissionForm.controls['note_suivi_'+i].patchValue(this.suiviNotesList[i].body);
         }
     
        this.submissionPropositions(this.submissionId);

        flatpickr("#soumission_created_date", {
          defaultDate: this.submissionInfo.created
        });
        setTimeout(() => {
              let suivi_start_date:any;

              if(this.suiviNotesList.length){
                let date_string = this.suiviNotesList[this.suiviNotesList.length-1].start_date;
                console.log('raw ',this.suiviNotesList[this.suiviNotesList.length-1].start_date );
                suivi_start_date = formatDate(date_string, 'YYYY-M-dd', 'en');
                //suivi_start_date = moment(date_string).format('YYYY-M-D');
              }

              console.log('suivi_start_date 1',suivi_start_date); //format('YYYY-MM-DD')

              this.calendarPick = flatpickr("#note_start_date_pkr_"+Number(this.suiviNotesList.length-1), {
                enableTime: false,
                defaultDate: suivi_start_date,
                dateFormat: 'Y-m-d',
              });

          }, 500);


          //  defaultDate: moment(suivi_start_date).format('YYYY-MM-DD'),
      
/*
        flatpickr("#build_date", {
          defaultDate: this.submissionInfo.build_date
        });
*/
      },
      error: err => {
        console.log("Something went wrong fetching submission: ", err)
      }
    });
  }

  
  readyCKEditor(event:any) {
    console.log('********************window[CKEDITOR]', event.editor.config);
    event.editor.config.versionCheck = false;

  }

  // On file Select
  onFileSelected(event: any) {
    this.fileList = event.target.files;

    if (this.fileList) {
      for (let i = 0; i < this.fileList.length; i++) {
        const reader = new FileReader();
        
        reader.readAsDataURL(this.fileList[i]);

        reader.onloadend = () => {
          console.log('file selected', this.fileList[i].name);
          this.filesUpload.push(
            { 
              base64String: reader.result,
              fileName: this.fileList[i].name
            }
          );

        }         
      }
    }
  }

  deleteFile(file: any) {
    const newFileList = Array.from(this.fileList);
    
    this.filesUpload.splice(file, 1)
    newFileList.splice(file, 1);
    this.fileList = newFileList;
    
  }

  // Upload new files
  uploadNewFiles():void  {
    let lastOneReload = false;
      for (let i = 0; i < this.filesUpload.length; i++ ){
        if(i+1 == this.filesUpload.length) {
          lastOneReload = true;
        }
        console.log('file uploading ', this.filesUpload[i]['fileName']);
        this.update_message_upload = this.filesUpload[i]['fileName'] +' - en cours de téléversement .... ';
        this.onUpload(this.filesUpload[i],  lastOneReload);
      }
      this.filesUpload =[];
      console.log('uploaded');
  }

  onUpload(oneFile: any, lastOneReload: any): void {
    console.log("upload file: ", oneFile);

    let fileInfos: any = {
      submission_id : this.submissionId,
      file_name : oneFile['fileName'],
      file : oneFile['base64String'],
    }

    this.files.uploadFile$(this.contactUUID, fileInfos).subscribe({
      next: data => {
        // this.clientInfo = data;
        console.log("uploaded: ",fileInfos['file_name']);
        this.update_message_upload = fileInfos['file_name'] +' - téléversé';
        if(lastOneReload){
           window.location.reload();
        }
      },
      error: err => {
        console.log("Something went wrong fetching file: ", err)
      }
    });
  }

  deleteExistingFile(file_id: any, file_name:any) {
    console.log('deleting file id', file_id);
    if(confirm("Voulez-vous supprimer le fichier "+ file_name)) {
      this.files.deleteFile$(this.contactUUID, file_id).subscribe({
        next: data => {
        // this.clientInfo = data;
        console.log("deleted a file successfully: ", data)
        window.location.reload();
        },
        error: err => {
          console.log("Something went wrong deleting a file: ", err)
        }
      });
    }

  }

  getClient(client: number): void {

    //console.log('client', client);
    this.clients.getClient$(this.contactUUID, client).subscribe({
      next: data => {
        this.clientInfo = data;
        console.log('loading client', this.clientInfo);
      },
      error: err => {
        console.log("Something went wrong fetching the client: ", err)
      }
    });
  }

  getBuildingInfo(buildingId: number): void {
    this.buildings.getBuilding$(this.contactUUID, buildingId).subscribe({
      next: data => {
        this.buildingInfo = data;
        console.log("Success getting building info: ", data);
        this.submissionInfo.building_updated = data.updated;
        //this.buildingInfo.roof_age = data.roof_age;
        //console.log("building info to SubmissionInfo var: ", this.submissionInfo);
      },
      error: err => {
        console.log("Something went wrong fetching building info: ", err)
      }
    });
  }
  

  goToTop() {
    console.log('should have went to top');
    //window.location.hash='#topofpage';

    /*
    angular.module('portfolio').value('$anchorScroll', angular.noop);

    var chartHelp = document.getElementById('chart-help');

    window.scrollToElement(chartHelp, 30, 500).then(function() {
        console && console.log('You just scrolled to chart-help!');
    });
   */
    //window.scrollTo( '#top' , 0 );
/*
    window.scrollTo({
      top: 0,
      left: 0,
      
    })
    */
  
  }

  onSubmit(formValues: any): void {
    console.log("All values ", formValues)


    let is_suivi_active_adjusted = formValues.is_suivi_active;
    console.log('--suivi_active b4 :', is_suivi_active_adjusted);
    console.log('this.submissionInfo.is_refused :', this.submissionInfo.is_refused);
    console.log('formValues.is_refused :', formValues.is_refused);
    console.log('formValues.is_signed:', formValues.is_signed);

    //close suivis if submission is set to refused, inverse has opposite effect unless contract signed (remains true)
    if(formValues.is_refused == true){
      is_suivi_active_adjusted = false;
      this.submissionInfo.is_suivi_active = false;
      //this.editSubmissionForm.controls['is_suivi_active'].patchValue(this.submissionInfo.is_suivi_active);
      console.log('---refused true, suivi becomes:', is_suivi_active_adjusted);
    }else if(this.submissionInfo.is_refused == true && formValues.is_refused == false && formValues.is_signed == false ){
      is_suivi_active_adjusted = true;
      this.submissionInfo.is_suivi_active = true;
      //this.editSubmissionForm.controls['is_suivi_active'].patchValue(this.submissionInfo.is_suivi_active);
      console.log('---refused false, suivi becomes:', is_suivi_active_adjusted);
    }else if(formValues.is_suivi_active == true && formValues.is_signed == false ){
      is_suivi_active_adjusted = true;
      this.submissionInfo.is_suivi_active = true;
      console.log('---set to active, suivi becomes:', is_suivi_active_adjusted);
    }else {
      is_suivi_active_adjusted = false;
      this.submissionInfo.is_suivi_active = false;
      console.log('---default, suivi becomes:', is_suivi_active_adjusted);
    }

    this.editSubmissionForm.controls['is_suivi_active'].patchValue(is_suivi_active_adjusted);
    //set it for css
    this.submissionInfo.is_refused = formValues.is_refused;
    console.log('suivi_active after :', is_suivi_active_adjusted);

    let submissionStateInfos: any = {
      "submission_state_id": this.submissionInfo.submission_state_id,
      "updated": this.submissionInfo.state_updated,
      "is_refused": formValues.is_refused,
      "is_scanned": this.submissionInfo.is_scanned,
      "is_accepted": formValues.is_accepted,
      "is_signed": formValues.is_signed,
      "is_sent": formValues.is_sent,
      "has_contract": this.submissionInfo.has_contract,
      "has_contract_signed": this.submissionInfo.has_contract_signed,
      "is_job_planned": this.submissionInfo.is_job_planned,
      "is_suivi_active": is_suivi_active_adjusted,
      "suivi_was_active": this.submissionInfo.suivi_was_active,
      "is_suivi_rv_active": this.submissionInfo.is_suivi_rv_active,
      "is_prep_security_done": this.submissionInfo.is_prep_security_done,
      "is_appel_service": this.submissionInfo.is_appel_service,
      "is_appel_service_active": this.submissionInfo.is_appel_service_active,
    }
    console.log(  'filling roof date:', formValues.roof_date,)

    let buildingInfos: any = {
      "building_id": this.submissionInfo.building_id,
      "submission_id": this.submissionInfo.submission_id,
      "updated": this.submissionInfo.building_updated,
      //work address
      "address": formValues.address,
      "address2": formValues.address2,
      "city": formValues.city,
      "province": formValues.province,
      "country": formValues.country,
      "postalcode": formValues.postalcode,
      //building info
      "roof_type_id": formValues.roof_type_id,
      "roof_description": formValues.roof_description,
      "building_type_id": formValues.building_type_id,
      "building_description": formValues.building_description,
      "building_access_id": formValues.building_access_id,
      "roof_access": formValues.roof_access,
      "has_water_infiltration": formValues.has_water_infiltration,
      "water_infiltration":formValues.water_infiltration,
      //extra info
      "is_new": formValues.is_new,
      "building_age": formValues.building_age,
      "roof_date": formValues.roof_date,
      "is_roof_redone": formValues.is_roof_redone,
      "build_date": formValues.build_date,
      "description": formValues.description,
    }

    //this.submitSubmissionState(submissionStateInfos);

    let submissionInfos: any = {
      "submission_no": formValues.submission_no,
      "client_id": this.submissionInfo.client_id,
      "active": this.submissionInfo.active,
      "updated": this.submissionInfo.updated
    }

    this.submitSubmissionInfo(submissionInfos, submissionStateInfos, buildingInfos);


    //this.submitBuildingInfo(buildingInfos);

    console.log('length', this.suiviNotesList.length);

    // the most future suivi date for the loop of suivis
    let running_future_suivi_date: any = moment(new Date('1 jan 2010')).toISOString();
    let max_i = this.suiviNotesList.length-1;
    let switch_save = true;
    let final_switch_save = true;
    this.update_message_suivi = '';
    //check for next suivi date consistency 

    for (let i = 0; i < this.suiviNotesList.length; i++ ) {

      console.log('switch_save', switch_save);
      console.log('running previous suivi date ', formatDate(running_future_suivi_date,'yyyy-MM-dd','en_US') );
      console.log('current suivi date ', formatDate(formValues['note_start_date_'+ i],'yyyy-MM-dd','en_US') );

      if (switch_save && ( formatDate(running_future_suivi_date,'yyyy-MM-dd','en_US') <= formatDate(formValues['note_start_date_'+ i],'yyyy-MM-dd','en_US'))){
        running_future_suivi_date =  moment(new Date( formValues['note_start_date_'+ i])).toISOString();
      }else{
        /*
        if(confirm('Une date ultérieure ('+ formatDate(running_future_suivi_date,'yyyy-MM-dd','en_US')  +  ')' +
        ' a été trouvée dans le calendrier des suivis pour cette soumission. \r\n' +
        "Voulez-vous enregistrer le suivi dans le calendrier à la date suivante: \r\n" + formatDate(formValues['note_start_date_'+ i],'yyyy-MM-dd','en_US')  +  "\r\n (l'encien suivi sera modifié)")){

          */
          switch_save = false;
          console.log('switch_save', switch_save);
          /*
        }else{
          switch_save = false;
        }
        */
      }
    }

    //latest date is not the latest suivi
    if( !switch_save && is_suivi_active_adjusted) {
        
        if(confirm('Une date ultérieure ('+ formatDate(running_future_suivi_date,'yyyy-MM-dd','en_US')  +  ')' +
        ' a été trouvée dans le calendrier des suivis pour cette soumission. \r\n' +
        "Voulez-vous enregistrer le suivi dans le calendrier à la date suivante: \r\n" + formatDate(formValues['note_start_date_'+ max_i],'yyyy-MM-dd','en_US')  +  "\r\n (l'encien suivi sera modifié)")){
            //overwrite previous dates
            final_switch_save = true;
        }else{ //don't save suivis
          final_switch_save = false;
          this.update_message_suivi = "Les suivis n'ont pas été modifiés à votre demande";
        }

    }else{
      //save the suivis as the last one has the furthest date
      final_switch_save = true;
       
    }

    if(final_switch_save ){
        for (let i = 0; i < this.suiviNotesList.length; i++ ) {
                  
          console.log('switch save', switch_save);
          console.log('update note', formValues['note_id_'+i]);
          console.log('start date of the above', moment(formValues['note_start_date_'+i]).toISOString());
          console.log('-------previous suivi date ', running_future_suivi_date );
          console.log('next suivi date ', formValues['note_start_date_'+i]);
    
          console.log('---------------SAVED SUIVIS ');
          let start_date_current  = moment(formValues['note_start_date_'+i]).toISOString();
          //check if you need to modify some 'prochain suivi dates
          if(formatDate(formValues['note_start_date_'+ max_i],'yyyy-MM-dd','en_US') < formatDate(formValues['note_start_date_'+ i],'yyyy-MM-dd','en_US')){
            //save previous suivi with new date  
            start_date_current = moment(formValues['note_start_date_'+max_i]).toISOString();
          }//else keep the dates as is

                //set & save current suivi
                let submissionNoteInfos: any = {
                  "note_id" : formValues['note_id_'+i],
                  "entity_id": this.submissionInfo.submission_id,
                  "updated": this.suiviNotesList[i].updated,
                  "body": formValues['note_suivi_'+i],
                  "start_date":start_date_current,
                  "end_date":  start_date_current,
                }
                this.submitSuiviNoteInfo(submissionNoteInfos);
        }
    } 

   

    /*
    for (let i = 0; i < this.suiviNotesList.length; i++ ) {
              
      let start_date_current  = moment(formValues['note_start_date_'+i]).toISOString();

            //set & save current suivi
            let submissionNoteInfos: any = {
              "note_id" : formValues['note_id_'+i],
              "entity_id": this.submissionInfo.submission_id,
              "updated": this.suiviNotesList[i].updated,
              "body": formValues['note_suivi_'+i],
              "start_date":start_date_current,
              "end_date":  start_date_current,
            }
            this.submitSuiviNoteInfo(submissionNoteInfos);
    }
    */
    // Upload files
    this.uploadNewFiles();
    //console.log('files upload', this.filesUpload);
  }

  submitSubmissionState(info: any): void {
    this.submissions.updateSubmissionState$(this.submissionId, this.contactUUID, info).subscribe({
      next: data => {
        console.log("Success updating the submission status: ", data);
        this.submissionInfo.state_updated = data.updated;
      },
      error: err => {
        console.log("Something went wrong while updating the submission status: ", err)
      }
    });
  }

  submitSubmissionInfo(info: any, submissionStateInfos: any, buldingInfos: any): void {

    this.buildingInfo = buldingInfos;
    this.submissionStateInfo = submissionStateInfos;
    this.submissions.updateSubmission$(this.submissionId, this.contactUUID, info).subscribe({
      next: data => {
        console.log("Success updating the submission: ", data);
        this.submitSubmissionState(this.submissionStateInfo);
        this.submissionInfo.updated = data.updated;
        this.submitBuildingInfo(this.buildingInfo);
      },
      error: err => {
        console.log("Something went wrong while updating the submission: ", err)
      }
    });
  }

  submitBuildingInfo(info: any): void {
    this.buildings.updateBuilding$(this.contactUUID, info).subscribe({
      next: data => {
        this.update_message = "mise à jour effectuée";
        console.log("Success updating the building: ", data);
        this.submissionInfo.building_updated = data.updated;
        this.submissionInfo.roof_date = data.roof_date;
        console.log("roof_date ", this.submissionInfo.roof_date);
        //force reload of field here
       // this.editSubmissionForm.controls['roof_date'].patchValue(data.roof_date);
        this.goToTop();
      },
      error: err => {
        console.log("Something went wrong while updating the building info: ", err)
      }
    })
  }

  submitFiles(files: any): void {
    this.notes.uploadFiles$(this.contactUUID, 2, files).subscribe({
      next: data => {
        console.log("Success updating the file(s): ", data)
      },
      error: err => {
        console.log("Something went wrong while updating the file(s): ", err)
      }
    })
  }

  proposition(id: any, name: string): void {
    this.templates.getTemplate$(id, this.contactUUID).subscribe({
      next: data => {
        this.propositionTemplateId = data.template_id;
        this.propositionTemplateName = name;
        this.propositionTemplate = data.template;
        this.addPropositionForm.controls['template_id'].patchValue(data.template_id);
        this.addPropositionForm.controls['proposition_name'].patchValue(name);
        this.addPropositionForm.controls['proposition_content'].patchValue(data.template);
      },
      error: err => {
        console.log("Something went wrong while fetching the proposition: ", err)
      }
    });
  }

  submissionPropositions(submissionId: number): void {
    this.propositions.getSubmissionPropositions$(this.contactUUID, submissionId).subscribe({
      next: data => {
        this.propositionsList = data;
        this.propositionsList = data.reverse();
        for (let oneProposition of this.propositionsList ){
          //oneProposition.proposition_date = moment(new Date(oneProposition.proposition_date)).locale('fr').format('D MMMM YYYY HH:mm');
          //oneProposition.updated = moment(new Date(oneProposition.updated)).locale('fr').format('D MMMM YYYY HH:mm');
        } 
        console.log('this.propositionsList', this.propositionsList);
      },
      error: err => {
        console.log("Something went wrong while submitting the propositions: ", err)
      }
    });
  }

  saveProposition(templateContent: any): void {
    const submissionid = this.activatedRoute.snapshot.params['submissionid'];

    console.log('content', templateContent);
    
    const d = new Date(), 
      year = d.getFullYear(),
      month = d.getMonth(),
      day = d.getDate();

    let propositionInfo: any = {
      "submission_id": submissionid,
      "template_id": templateContent.template_id,
      "proposition_name": templateContent.proposition_name,
      "proposition_date": d,
      "proposition": templateContent.proposition_content,

    }

    this.propositions.addProposition$(this.contactUUID, propositionInfo).subscribe({
      next: data => {
        const closeButton = document.querySelector(".btn-close") as HTMLElement | null;
        closeButton!.click();

        this.submissionPropositions(submissionid);

        console.log("Success adding proposition: ", data)
      },
      error: err => {
        console.log("Something went wrong while adding proposition: ", err.error.errors)
      }
    });
  }

  updateProposition(propositionContent: any): void {
    const d = new Date(), 
      year = d.getFullYear(),
      month = d.getMonth(),
      day = d.getDate();

    let propositionInfo: any = {
      "proposition_id": this.singleProposition.proposition_id,
      "updated": this.singleProposition.updated,
      "submission_id": this.singleProposition.submission_id,
      "template_id": this.singleProposition.template_id,
      "proposition_name": this.propositionName,
      "proposition_date": this.singleProposition.proposition_date,
      "proposition": propositionContent.proposition_content !== "" ? propositionContent.proposition_content : this.propositionContent
    }

    this.propositions.updateProposition$(this.contactUUID, propositionInfo).subscribe({
      next: data => {
        const closeButton = document.querySelector("#updatePropositionForm-close") as HTMLElement | null;
        closeButton!.click();
        
        console.log("Success updating the proposition: ", data)
      },
      error: err => {
        console.log("Something went wrong while updating the proposition: ", err)
      }
    });
  }

  propositionEdit(proposition: number): void {
    this.propositions.getProposition$(proposition, this.contactUUID).subscribe({
      next: data => {
        this.singleProposition = data;
  
        this.propositionId = this.singleProposition.proposition_id;
        this.propositionName = this.singleProposition.proposition_name;
        this.propositionCreated = this.singleProposition.proposition_date;
        this.propositionLastUpdated = this.singleProposition.updated;
        this.propositionFirstSent = this.singleProposition.email_date;
        this.propositionContent = this.singleProposition.proposition;
      },
      error: err => {
        console.log("Something went wrong while editing the proposition: ", err)
      }
    });
  }

  propositionEmail(proposition: number): void {

    console.log('client', this.clientInfo);
    let client_contact_emails: any = '';

    for (let client_contact of this.clientInfo['contacts'] ){
        if(client_contact.client_contact_type_id == 4){
            client_contact_emails = client_contact_emails + ' ' + client_contact.value;
        }
    } 

    if (client_contact_emails.length == 0){
      if(confirm("Client "+ this.clientInfo['client_fname'] + " " + this.clientInfo['client_lname'] + " n'a pas de courriel. Ajouter un courriel au client pour lui envoyer le document. \r\n ")){}

    }else{
      if(confirm("Envoyer cette soumission par courriel à ? \r\n \r\nCLIENT : "+ this.clientInfo['client_fname'] + " " + this.clientInfo['client_lname'] +
      " \r\nCOURRIEL(s) : " + client_contact_emails 
      )) {
        this.propositions.exportPropositionEmail$(this.contactUUID, proposition).subscribe({
          next: data => {
            this.update_message_prop = "Proposition a été envoyée au client avec succèss: "+ data.proposition_name;
            console.log("Success emailing the proposition: ", data);
            window.location.reload();
          },
          error: err => {
            console.log("Something went wrong while emailing the proposition: ", err.error.errors)
          }
        });
      }
    }
  }

  propositionPrint(proposition: number): void {
    this.propositions.exportPropositionPrint$(this.contactUUID, proposition).subscribe({
      next: data => {
        console.log("Success printing the proposition: ", data)

        let printContents, popupWin: any;
        printContents = document.getElementById('print-section')!.innerHTML;
        popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
        popupWin.document.open();
        popupWin.document.write(data.proposition);
        setTimeout(function() {
          popupWin.document.close();
          popupWin.window.print();
        }, 250);
      },
      error: err => {
        console.log("Something went wrong printing the proposition: ", err.error.errors)
      }
    });
  }

  propositionPrintPDF(proposition: number, name: string): void {   

    this.http.post(this.baseUrl + `/propositions/` + proposition + `/export/pdf?uuid=` + this.contactUUID, proposition, { responseType: 'blob'}).subscribe(res =>{
      let blob = new Blob([res], { type: 'application/pdf' });
      let pdfUrl = window.URL.createObjectURL(blob);

      let popupWin: any;
      popupWin = window.open(pdfUrl, '_blank', 'top=0,left=0,height=100%,width=auto');

      setTimeout(function() {
        popupWin.window.print();
      }, 250);

    });

  }

  propositionPdf(proposition: number, name: string): void {
    // TO DO Clean up using the service
    this.http.post(this.baseUrl + `/propositions/` + proposition + `/export/pdf?uuid=` + this.contactUUID, proposition, { responseType: 'blob'}).subscribe(res =>{
      let blob = new Blob([res], { type: 'application/pdf' });
      let pdfUrl = window.URL.createObjectURL(blob);

      var PDF_link = document.createElement('a');
      PDF_link.href = pdfUrl;
      // TO OPEN PDF ON BROWSER IN NEW TAB
      window.open(pdfUrl, '_blank');
      // TO DOWNLOAD PDF TO YOUR COMPUTER
      PDF_link.download = name +".pdf";
      PDF_link.click();
    });
  }

  sanitizePhone(phoneNumber: string): string {

    let phoneNumberSanitized = phoneNumber.replace(/\D/g, '');
    phoneNumberSanitized = phoneNumberSanitized.substring(0, 10);
    //console.log('phoneNumberSanitized: ', phoneNumberSanitized);
    return phoneNumberSanitized;
  }

  invoicePdf(invoice: number, name: string): void {
    // TO DO Clean up using the service
    this.http.post(this.baseUrl + `/invoices/` + invoice + `/export/pdf?uuid=` + this.contactUUID, invoice, { responseType: 'blob'}).subscribe(res =>{
      let blob = new Blob([res], { type: 'application/pdf' });
      let pdfUrl = window.URL.createObjectURL(blob);

      let popupWin: any;
      popupWin = window.open(pdfUrl, '_blank', 'top=0,left=0,height=100%,width=auto');

    });
  }

  fileExport(fileId: number, name: string, contentType: string): void {
    // TO DO Clean up using the service
    this.http.get(this.baseUrl + `/notes/file/download/` + fileId + `?uuid=` + this.contactUUID, { responseType: 'blob'}).subscribe(res =>{
      let blob = new Blob([res], { type: contentType });
      let pdfUrl = window.URL.createObjectURL(blob);

      var PDF_link = document.createElement('a');
      PDF_link.href = pdfUrl;
      //PDF_link.download = name;

      console.log('link', PDF_link, fileId );
      // TO OPEN PDF ON BROWSER IN NEW TAB
      window.open(pdfUrl, '_blank');

    });
  }

  fileDownload(fileId: number, name: string, contentType: string): void {
      // TO DO Clean up using the service
      this.http.get(this.baseUrl + `/notes/file/download/` + fileId + `?uuid=` + this.contactUUID, { responseType: 'blob'}).subscribe(res =>{
        let blob = new Blob([res], { type: contentType });
        let pdfUrl = window.URL.createObjectURL(blob);
  
        var PDF_link = document.createElement('a');
        PDF_link.href = pdfUrl;
        PDF_link.setAttribute("download", name);
  
        console.log('link', PDF_link, fileId );
        
        // TO DOWNLOAD PDF TO YOUR COMPUTER
        PDF_link.download = name;
        PDF_link.click();

      });
  }

  propositionDuplicate(proposition: number, name: string): void {
    const submissionid = this.activatedRoute.snapshot.params['submissionid'];

    this.propositions.duplicateProposition$(this.contactUUID, proposition).subscribe({
      next: data => {
        console.log("Success duplicating the proposition: ", data);
        this.update_message_prop = "Nouvelle proposition ajoutée avec succèss: "+data.proposition_name;
        this.submissionPropositions(submissionid);
      },
      error: err => {
        console.log("Something went wrong while duplicating the proposition: ", err.error.errors)
      }
    });
  }

  propositionDelete(propositionId: number, propositionUpdated: number): void {

    let propositionInfo: any = {
      "proposition_id": propositionId,
      "updated": propositionUpdated,
      "deleted": moment(new Date()),
    }

    console.log("deleted", moment(new Date()));


    this.propositions.deleteProposition$(this.contactUUID, propositionInfo).subscribe({
      next: data => {
        console.log("Success deleting the proposition: ", data);
        //this.update_message_prop = "Proposition a été supprimé avec succèss ";
        window.location.reload();
      },
      error: err => {
        console.log("Something went wrong deleting the proposition: ", err.error.errors)
      }
    });
  }

  submitSuiviNoteInfo(info: any): void {
    this.notes.updateNote$(this.contactUUID, info).subscribe({
      next: data => {
        this.update_message = "mise à jour effectuée";
       // console.log("Success updating the suivi note: ", data);
        //this.submissionInfo.building_updated = data.updated;
        this.goToTop();
      },
      error: err => {
        console.log("Something went wrong while updating suivi notes: ", err)
      }
    })
  }

  /*  Add an extra empty suivi field */
  addSuiviNote(): void  {
    const submissionid = this.activatedRoute.snapshot.params['submissionid'];
    
    let submissionNoteInfo: any = {
      "note_type_id": 1,
      "note_entity_id": 2,
      "entity_id": submissionid,
      "subject": '',
      "body": '',
      "start_date": moment(new Date()).add(4, 'days'),
      "end_date":  moment(new Date()).add(4, 'days'),
    }

    this.notes.addSubmissionNote$(this.contactUUID, submissionNoteInfo).subscribe({
      next: data => {
        this.suiviNotesList.push({
          "note_id" : data.note_id,
          "body":  data.body,
          "first_name": data.first_name,
          "last_name": data.last_name,
          "created": moment(data.created).format('YYYY-MM-DD HH:mm') ,
          "start_date": data.start_date,
          "end_date": data.end_date,
          "updated": data.updated,
        })
        let i = this.suiviNotesList.length-1;
        let default_date = moment(this.suiviNotesList[i].start_date).format('YYYY-MM-DD');
        var next_suivi_date = moment(default_date).add(4, 'days');

        console.log('Adding next date ', next_suivi_date );

  /*
        this.calendarPick = flatpickr("#note_start_date_pkr_"+Number(this.suiviNotesList.length-1), {
          defaultDate: moment(default_date).add(4, 'days').format('YYYY-MM-DD'),
        });   
*/
        
      setTimeout(() => {
          this.calendarPick = flatpickr("#note_start_date_pkr_"+Number(this.suiviNotesList.length-1), {
            enableTime: false,
            defaultDate: moment(default_date).format('YYYY-MM-DD'),
        });
      }, 500);


        console.log('this.calendarPick ', this.calendarPick );

        const input = document.querySelector('#note_start_date_pkr_'+Number(this.suiviNotesList.length-1)) as HTMLInputElement | null;
        //window.location.reload();
        const input2 = document.getElementById('#note_start_date_pkr_'+Number(this.suiviNotesList.length-1)) as HTMLInputElement | null;
    

        console.log('iter', this.suiviNotesList.length-1);

        if (input2 != null) {
            console.log('input of calpick', input2.value); // 👉️ "Initial value"
        }else{
          console.log('input of null calpick', input2); 
        }

        this.editSubmissionForm.addControl('note_id_'+i, new FormControl(""));
        this.editSubmissionForm.controls['note_id_'+i].patchValue(this.suiviNotesList[i].note_id);
        this.editSubmissionForm.addControl('note_start_date_'+i, new FormControl(""));
        this.editSubmissionForm.controls['note_start_date_'+i].patchValue( moment(this.suiviNotesList[i].start_date).format('YYYY-MM-DD'));
        this.editSubmissionForm.addControl('note_suivi_'+i, new FormControl(""));
        this.editSubmissionForm.controls['note_suivi_'+i].patchValue(this.suiviNotesList[i].body);
       // console.log('suivi_start_date',this.editSubmissionForm.controls['note_start_date_'+i]);

       
       console.log('DEFAULT start DATE',default_date );
       
     
        console.log("Success adding suivi note: ", data);
        console.log ('returning suivi note: ', this.suiviNotesList);
      },
      error: err => {
        console.log("Something went wrong while adding suivi note: ", err.error.errors)
      }
    });
  }

  deleteSuiviNote(note_order: number, note_id: any) {
    const newSuiviNotesList = Array.from(this.suiviNotesList);

    if(confirm("Voulez-vous supprimer ce suivi ?")) {
      console.log('inside deleting ');
      
      //this.filesUpload.splice(file, 1)
      newSuiviNotesList.splice(note_order, 1);
      this.suiviNotesList = newSuiviNotesList;
      console.log('deleting Note: ', note_id);

      let noteInfo: any = {
        "note_id": note_id,
      }

        this.notes.deleteNote$(this.contactUUID, note_id, noteInfo).subscribe({
          next: data => {
                  console.log("Success deleting suivi note: ", data);
                  let i = this.suiviNotesList.length-1;
                  let default_date = moment(this.suiviNotesList[i].start_date).format('YYYY-MM-DD');
                  var next_suivi_date = moment(default_date).add(4, 'days');

                  setTimeout(() => {
                    this.calendarPick = flatpickr("#note_start_date_pkr_"+Number(this.suiviNotesList.length-1), {
                      enableTime: false,
                      defaultDate: moment(default_date).format('YYYY-MM-DD'),
                  });
                  }, 500);
          
          },
          error: err => {
            console.log("Something went wrong while deleting suivi note: ", err.error.errors)
          }
        });
      
      }
    }

}